import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import Background from "./Background";
import Theme from "./Theme";
import LiveChatWidgetAddon from "./LiveChatWidgetAddon";
import WhatsAppAddon from "./WhatsAppAddon";
import AllowedCountriesAddon from "./AllowedCountriesAddon";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Addons extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Addons.background_attribute_name]: Background,
      [Addons.theme_attribute_name]: Theme,
      [Addons.show_sale_page_navbar_attribute_name]: true,
      [Addons.show_sale_page_footer_attribute_name]: true,
      [Addons.sticky_buy_button_attribute_name]: true,
      [Addons.visible_button_price_attribute_name]: false,
      [Addons.disable_selection_and_context_menu_attribute_name]: false,
      [Addons.include_in_home_and_product_page_attribute_name]: true,
      [Addons.live_chat_widget_attribute_name]: LiveChatWidgetAddon,
      [Addons.whatsapp_button_attribute_name]: WhatsAppAddon,
      [Addons.allowed_countries_attribute_name]: AllowedCountriesAddon
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getBackgroundAttributeName() {
    return this.background_attribute_name;
  }
  static getThemeAttributeName() {
    return this.theme_attribute_name;
  }
  static getNavbarAttributeName() {
    return this.show_sale_page_navbar_attribute_name;
  }
  static getFooterAttributeName() {
    return this.show_sale_page_footer_attribute_name;
  }
  static getDisableSelectionAndContextMenuAttributeName() {
    return this.disable_selection_and_context_menu_attribute_name;
  }
  static getIncludeInHomeAndProductPageAttributeName() {
    return this.include_in_home_and_product_page_attribute_name;
  }
  static getStickyBuyButtonAttributeName() {
    return this.sticky_buy_button_attribute_name;
  }
  static getVisibleButtonPriceAttributeName() {
    return this.visible_button_price_attribute_name;
  }
  static getLiveChatWidgetAddonAttributeName() {
    return this.live_chat_widget_attribute_name;
  }
  static getWhatsAppButtonAttributeName() {
    return this.whatsapp_button_attribute_name;
  }
  static getAllowedCountriesAttributeName() {
    return this.allowed_countries_attribute_name;
  }
  getWhatsApp() {
    return this.getAttribute(Addons.whatsapp_button_attribute_name);
  }
  hasWhatsApp() {
    let whatsApp = this.getWhatsApp();
    return whatsApp instanceof WhatsAppAddon ? whatsApp.isActive() : false;
  }
  getTheme() {
    return this.getAttribute(Addons.theme_attribute_name);
  }
  hasNavBar() {
    return this.getAttribute(Addons.show_sale_page_navbar_attribute_name);
  }
  hasFooter() {
    return this.getAttribute(Addons.show_sale_page_footer_attribute_name);
  }
  getBackground() {
    return this.getAttribute(Addons.getBackgroundAttributeName());
  }
  isBackgroundEnabled() {
    const background = this.getBackground();
    return background instanceof Background && background.isEnabled();
  }
  getBackgroundColor() {
    const background = this.getBackground();
    return background instanceof Background ? background.getColor() : null;
  }
}
_defineProperty(Addons, "background_attribute_name", 'background');
_defineProperty(Addons, "theme_attribute_name", 'theme');
_defineProperty(Addons, "show_sale_page_navbar_attribute_name", 'show_sale_page_navbar');
_defineProperty(Addons, "show_sale_page_footer_attribute_name", 'show_sale_page_footer');
_defineProperty(Addons, "sticky_buy_button_attribute_name", 'sticky_buy_button');
_defineProperty(Addons, "visible_button_price_attribute_name", 'visible_button_price');
_defineProperty(Addons, "disable_selection_and_context_menu_attribute_name", 'disable_selection_and_context_menu');
_defineProperty(Addons, "include_in_home_and_product_page_attribute_name", 'include_in_home_and_product_page');
_defineProperty(Addons, "live_chat_widget_attribute_name", 'live_chat_widget');
_defineProperty(Addons, "whatsapp_button_attribute_name", 'whatsapp_button');
_defineProperty(Addons, "allowed_countries_attribute_name", 'allowed_countries');